import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import SidebarSectionWrapper from './SidebarSectionWrapper';
import NavigationItem from './NavigationItem';
import SidebarDivider from '../../../components/SidebarDivider';
import useActiveRoute from '../../../hooks/useActiveRoute';
import { pagesText } from '../../../constants/pagesText';
import SidebarSectionTitle from './SidebarSectionTitle';
import BulkActionsMenu from '../../../components/BulkActionsMenu';
import { APP_COUNTS_KEY } from 'src/constants/query';
import { useQuery } from 'react-query';
import EnvironmentService from 'src/services/environment.service';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';

const SidebarNavigation = ({ sidebarNavigationList }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const { checkIsActiveRoute } = useActiveRoute();
  const location = useLocation();
  const [bulkAnchorEl, setBulkAnchorEl] = useState(null);

  const { data: appCounts } = useQuery([APP_COUNTS_KEY, customerEnvId], () =>
    EnvironmentService.getAppCounts({
      customerEnvId: customerEnvId,
    }),
  );

  console.log(appCounts);

  const navigationListCounts = useMemo(
    () => ({
      [pagesText.sidebarNavigation.apps]: appCounts?.applicationsCount,
      [pagesText.sidebarNavigation.devices]: appCounts?.deviceCount,
    }),
    [appCounts],
  );

  const onApplicationMenuOpen = useCallback(
    event => {
      setBulkAnchorEl(event.currentTarget);
    },
    [setBulkAnchorEl],
  );

  const onApplicationMenuClose = useCallback(() => {
    setBulkAnchorEl(null);
  }, [setBulkAnchorEl]);

  return (
    <>
      <SidebarSectionWrapper>
        <SidebarSectionTitle>Management</SidebarSectionTitle>
        <List
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}>
          {sidebarNavigationList.map(({ icon, title, path, canNavigate }) => (
            <NavigationItem
              key={title}
              icon={icon}
              path={title !== pagesText.sidebarNavigation.actions ? path : null}
              query={location.search}
              title={title}
              isActive={checkIsActiveRoute(path)}
              disabled={title === pagesText.sidebarNavigation.license}
              onClick={title === pagesText.sidebarNavigation.actions && onApplicationMenuOpen}
              canNavigate={canNavigate}
              count={navigationListCounts[title]}
            />
          ))}
        </List>
      </SidebarSectionWrapper>
      <SidebarDivider />
      <BulkActionsMenu anchorEl={bulkAnchorEl} onClose={onApplicationMenuClose} />
    </>
  );
};

export default SidebarNavigation;
